import script from "./ConstructorActionList.vue?vue&type=script&setup=true&lang=js"
export * from "./ConstructorActionList.vue?vue&type=script&setup=true&lang=js"

import "./ConstructorActionList.vue?vue&type=style&index=0&id=c0cd20ac&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0cd20ac"]])

export default __exports__